(function () {
  'use strict';

  /* ---------- 1. City dropdown: adaptive height + keep top row fully visible ---------- */
  function adjust(filter) {
    if (!filter) return;
    var input = document.querySelector('#city-search') || document.querySelector('#nova-poshta input');
    var inputTop = input ? input.getBoundingClientRect().top : filter.getBoundingClientRect().bottom;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var maxH = Math.max(140, Math.min(inputTop - 12, Math.round(vh * 0.6)));
    filter.style.setProperty('--np-dropdown-max-h', maxH + 'px');
    var reset = function () { try { if (filter.scrollTop < 0) filter.scrollTop = 0; } catch (e) {} };
    try { filter.scrollTop = 0; } catch (e) {}
    setTimeout(reset, 60);
    setTimeout(reset, 200);
    bindSettle(filter);
  }

  /* After the user stops scrolling, gently align the list to a whole row so the
     top item is never left half-hidden behind the frame (iOS momentum fix). */
  function bindSettle(filter) {
    if (filter.__npSettleBound) return;
    filter.__npSettleBound = true;
    var t;
    filter.addEventListener('scroll', function () {
      if (filter.scrollTop < 0) { filter.scrollTop = 0; return; }
      clearTimeout(t);
      t = setTimeout(function () {
        var item = filter.querySelector('a');
        if (!item) return;
        var h = item.getBoundingClientRect().height;
        if (!h) return;
        var pad = parseFloat(getComputedStyle(filter).paddingTop) || 0; var rem = ((filter.scrollTop - pad) % h + h) % h;
        if (false) { /* auto-scroll disabled per user request */
          var target = filter.scrollTop - rem; /* snap up to the row start */
          try { filter.scrollTo({ top: target, behavior: 'smooth' }); }
          catch (e) { filter.scrollTop = target; }
        }
      }, 120);
    }, { passive: true });
  }

  function handleAll() {
    document.querySelectorAll('#city_filter, #street_filter, #nova-poshta .dropdown-filter').forEach(adjust);
    syncOverlay();
  }

  /* ---------- Mobile overlay: pin the input at the top and let the results
     list flow DOWNWARD in its own scroll area, so it never floats above the
     focused input (kills the Android keyboard scroll-fight). Toggled by class
     so no :has() is needed (works on older Android webviews). ---------- */
  function syncOverlay() {
    var np = document.querySelector('#nova-poshta');
    if (!np) return;
    var active = np.querySelector('.dropdown-filter.active');
    /* Stay open while the search is active even if the list is momentarily
       empty between keystrokes (city results are cleared, then re-inserted
       ~500ms later) - otherwise the overlay collapses and re-expands on every
       character, which reads as the whole list blinking. */
    var open = !!active && (np.classList.contains('filter-active') || active.children.length > 0);
    var wantWrap = open ? active.closest('.city-wrap, .warehouse-wrap') : null;
    var curWrap = np.querySelector('.np-list-open');
    if (curWrap === wantWrap) return; /* no state change -> don't touch DOM (avoids observer feedback) */
    if (curWrap) curWrap.classList.remove('np-list-open');
    if (wantWrap) {
      wantWrap.classList.add('np-list-open');
      try { active.scrollTop = 0; } catch (e) {}
    }
  }
  function onField(e) {
    var t = e.target;
    if ((t && t.id === 'city-search') || (t.classList && t.classList.contains('search-city'))) {
      setTimeout(handleAll, 60);
    }
  }
  document.addEventListener('input', onField, true);
  document.addEventListener('focusin', onField, true);
  window.addEventListener('resize', function () { setTimeout(handleAll, 60); });

  var mo = new MutationObserver(function () { handleAll(); });
  function bootDropdown() {
    var np = document.querySelector('#nova-poshta');
    /* #nova-poshta is injected into the drawer long after page load, so retry
       until it exists - otherwise the observer never attaches and syncOverlay
       runs only on the (delayed) input events, applying the class racily. */
    if (!np) { return false; }
    mo.observe(np, { childList: true, subtree: true });
    handleAll();
    return true;
  }

  /* ---------- 2. Lock page scroll while the cart drawer is open ---------- */
  var savedScrollY = 0;
  var locked = false;
  function lock() {
    if (locked) return;
    locked = true;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-savedScrollY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }
  function isOpen(drawer) {
    return drawer && !drawer.classList.contains('qsc2-drawer--hidden');
  }
  function watchDrawer() {
    var drawer = document.querySelector('.qsc2-drawer');
    if (!drawer) return false;
    var sync = function () { if (isOpen(drawer)) lock(); else unlock(); };
    var dmo = new MutationObserver(sync);
    dmo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
    return true;
  }

  function boot() {
    if (!bootDropdown()) {
      /* #nova-poshta is injected into the drawer after load - retry */
      var dTries = 0;
      var dIv = setInterval(function () {
        if (bootDropdown() || ++dTries > 60) clearInterval(dIv);
      }, 500);
    }
    if (!watchDrawer()) {
      /* drawer markup is injected by the app after load - retry */
      var tries = 0;
      var iv = setInterval(function () {
        if (watchDrawer() || ++tries > 40) clearInterval(iv);
      }, 500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
/* Lock the cart drawer's own scroll while the NP dropdown is open, so touch scroll stays in the list */
function watchNpDropdown() {
  var np = document.querySelector('#nova-poshta');
  if (!np) return false;
  var apply = function () {
    /* Drive the mobile overlay from here: this observer watches class changes
       on #nova-poshta's subtree (.active / .filter-active), which is exactly
       when the list opens and closes - reliable regardless of injection timing. */
    syncOverlay();
    var wrap = document.querySelector('.qsc2-drawer-wrapper');
    if (!wrap) return;
    var open = np.classList.contains('filter-active') || !!np.querySelector('.dropdown-filter.active');
    if (open) wrap.classList.add('np-lock-scroll');
    else wrap.classList.remove('np-lock-scroll');
  };
  var mo = new MutationObserver(apply);
  mo.observe(np, { attributes: true, subtree: true, attributeFilter: ['class'] });
  apply();
  return true;
}
                                    if (!watchNpDropdown()) {
                                      var npTries = 0;
                                        var npIv = setInterval(function () {
                                            if (watchNpDropdown() || ++npTries > 40) clearInterval(npIv);
                                              }, 500);
                                              }
                                              })();
